<template>
  <v-app background-color="darkgrey">
      <Header v-bind:info="info"/>
    <v-content>
      <Companies v-bind:Companies="Companies"/>
      <Teams v-bind:Teams="Teams"/>
      <Technologies v-bind:technologies="technologies"/>
    </v-content>
  </v-app>
</template>

<script>
import Header from './components/Header'
import Teams from './components/Teams'
import Companies from './components/Companies'
import Technologies from './components/Technologies'

export default {
  name: 'App',
  components: {
    Header,
    Teams,
    Companies,
    Technologies
  },
  data() {
    return {
      info: {
        twitter: 'https://twitter.com/ArlonAntonius',
        facebook: 'https://facebook.com/ArlonAntonius',
        github: 'https://github.com/ArlonAntonius',
        email: 'ArlonAntonius@gmail.com'
      },
      Companies:{
        centric: {
          name: '6Centric',
          description: "My company focused on providing amazing services in all aspects of business. It's main focus is providing online products for your business.",
          type: 'mine',
          color: '#00AEEF',
          twitter: 'https://twitter.com/6Centric',
          site: 'http://6centric.com/'
        },
      },
      Teams: [
        {
          name: 'Laravel Tenancy',
          description: "Tenancy is the toolkit for developing multi tenant project with Laravel by enabling developers around the world in bringing to production their wildest and most complex ideas. ",
          type: 'opensource',
          color: '#ff9a65',
          twitter: 'https://twitter.com/LaravelTenancy'
        },
        {
          name: 'To be announced',
          description: 'Something new related to entertainment...',
          type: 'commercial',
          color: 'darkgrey'
        },
      ],
      technologies: [
        {
          name: 'Automation',
          type: 'Application',
          level: 100,
          years: 6,
          color: '#5a2aac',
        },
        {
          name: 'PHP',
          type: 'Backend',
          level: 80,
          years: 6,
          color: '#8892BF',
        },
        {
          name: 'Laravel',
          type: 'Backend',
          level: 80,
          years: 2,
          color: '#f05340'
        },
        {
          name: 'C#',
          type: 'Application',
          level: 40,
          years: 2.5,
          color: '#7B3399'
        },
        {
          name: 'Python',
          type: 'Application',
          level: 30,
          years: 3,
          color: '#3772A2'
        },
        {
          name: 'VueJS',
          type: 'Frontend',
          level: 20,
          years: 0,
          color: '#42b883'
        },
        {
          name: 'HTML CSS',
          type: 'Frontend',
          level: 40,
          years: 4,
          color: '#e34f26'
        },
        {
          name: 'JavaScript',
          type: 'Frontend',
          level: 80,
          years: 3,
          color: '#f7df1e'
        }
      ]
    }
  }
}
</script>

<style>
a{
  text-decoration: none;
}
</style>
